import React, { useContext, useEffect, useMemo, useState } from "react";
import { Typography, Grid, Stack, Divider, List, Card, Box, Sheet } from "@mui/joy";
import TableCustom from "../../components/TableCustome";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import PageLooperContext from "../../providers/PageLooperContext";
import { green, grey } from "@mui/material/colors";
import { CardMedia } from "@mui/material";
import getProduitImageUrl from "../../utils/getProduitImageUrl";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Colors from "../../constant/colors";
import getPrixMoyenProduitParProvince from "../../utils/getPrixMoyenProduitParProvince";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend,ChartDataLabels);

interface PrixMoyenneProvince {  // ← NOUVEAU
  province: string;
    marche: string;  

  moyenne: number;
  min: number;
  max: number;
  nbMarches: number;
  
}

const PrixMoyenProduitParprovince: React.FC<{ produit: string }> = ({ produit }) => {
const { cacheMoyennes, apiData } = useContext(PageLooperContext);  // apiData = nouvelle structure

  const [loading, setLoading] = useState(true);
  const [moyennes, setMoyennes] = useState<PrixMoyenneProvince[]>([]);  // ← TYPE CHANGÉ
  const [moyenneMin, setmoyenneMin] = useState<PrixMoyenneProvince>();
  const [moyenneMax, setmoyenneMax] = useState<PrixMoyenneProvince>();

  const loadData = async () => {
    // Filtrer par produit (nouvelle structure : produit.nomProduit)
    const res = apiData.filter((p) => p.produit.nomProduit === produit);
    
    const moyennesParProvince = getPrixMoyenProduitParProvince(res);  // ← NOUVEAU UTILITAIRE
    setMoyennes(moyennesParProvince); 
    setLoading(false);
    cacheMoyennes[`${produit}_province`] = moyennesParProvince;  // ← CLÉ CACHE MODIFIÉE
  };


  // Code produit (inchangé)
  const codeProduit = useMemo(() => 
    apiData.find((p) => p.produit.nomProduit === produit)?.produit.codeProduit
  , [apiData, produit]);

  // useEffect chargement (ajouter clé cache différente)
  useEffect(() => {
    const cacheKey = `${produit}_province`;
    if (cacheMoyennes[cacheKey]) {
      setMoyennes(cacheMoyennes[cacheKey]);
      setLoading(false);
      return;
    }
    loadData();
  }, [produit, cacheMoyennes]);

  // Min/Max (CHANGÉ : moyenne → province)
  useEffect(() => {
    if (moyennes.length) {
      setmoyenneMin(moyennes.reduce((prev, curr) => 
        prev.moyenne < curr.moyenne ? prev : curr
      ));
      setmoyenneMax(moyennes.reduce((prev, curr) => 
        prev.moyenne > curr.moyenne ? prev : curr
      ));
    }
  }, [moyennes]);
 

if (loading) {
  return (
    <Stack sx={{  justifyContent: 'center', alignItems: 'center' }}>
      <Typography fontSize="2vw" textAlign="center">
        Chargement des prix pour "{produit}"...
      </Typography>
    </Stack>
  );
}
    return (
        <Stack sx={{height: '100%',  width: '100%',  p: 2, gap: 1, overflow: 'hidden', bgcolor: '#f5f7fa' }}>
<Typography
  level="h4"
  fontSize="2vw"
  textColor={grey[700]}
  fontWeight={600}
>
  Prix moyen de{" "}
  <Typography component="span" fontWeight={700} textColor={green[900]}>
    {produit}
  </Typography>{" "}
  dans la Province de{" "}
  <Typography component="span" fontWeight={700} sx={{ color: Colors.primary }}>
     {moyennes[0]?.province}
  </Typography>
</Typography>

            <Grid container spacing={2} alignItems={'flex-start'} >
                {/* Tableau et image start */}
                <Grid xs={12} md={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1, minHeight: 0 }}>
                    <Card variant="outlined" sx={{ flex: 1, p: 1, overflow: 'auto' }}>
                        <Stack direction="row" gap={2}>
                            <CardMedia
                                component="img"
                                image={getProduitImageUrl(codeProduit || '')}
                                sx={{ width: 200, height: 200, borderRadius: 2, objectFit: "cover", boxShadow: 'sm' }}
                            />
                            <Box sx={{ flex: 1 }}>
                                <TableCustom
  columns={[
    { label: "Marchés", key: "marche" },  // ← CHANGÉ : Région → province
    { label: "Min", key: "minimum", center: true },
    { label: "Max", key: "maximum", center: true },
    { label: "Moyen", key: "moyenne", center: true },
    // { label: "Marchés", key: "nbMarches", center: true },
  ]}
  data={moyennes.map((m) => ({  // ← m.region → m.province
    marche: m.marche,  // ← NOUVEAU : afficher les marchés associés à la province
    moyenne: <Typography fontWeight={700}>{m.moyenne.toFixed(0)}</Typography>,
    minimum: m.min.toFixed(0), 
    maximum: m.max.toFixed(0),
    // nbMarches: m.nbMarches,
  }))}
/>

                            </Box>
                        </Stack>
                    </Card>

                    {/* POINTS À RETENIR (EN GRID POUR ÉCONOMISER L'ESPACE) */}
                    <Card variant="soft" color="neutral" sx={{ p: 1.5, bgcolor: 'white' }}>
                        <Typography level="title-sm" mb={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              Points clés
                        </Typography>
                        <Grid container spacing={1}>
                            <Grid xs={6}>
                                <Sheet variant="outlined" sx={{ p: 1, borderRadius: 'md', borderLeft: `4px solid ${green[500]}` }}>
                                    <Typography level="body-xs">Le moins cher :</Typography>
                                    <Typography level="title-sm">{moyenneMin?.province} ({moyenneMin?.moyenne.toFixed(0)} FCFA)</Typography>
                                </Sheet>
                            </Grid>
                            <Grid xs={6}>
                                <Sheet variant="outlined" sx={{ p: 1, borderRadius: 'md', borderLeft: `4px solid ${grey[800]}` }}>
                                    <Typography level="body-xs">Le plus élevé :</Typography>
                                    <Typography level="title-sm">{moyenneMax?.province} ({moyenneMax?.moyenne.toFixed(0)} FCFA)</Typography>
                                </Sheet>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                {/* Tableau et image end */}



{/* Graphique start  */}
 <Grid xs={12} md={4} sx={{ display: 'flex' }}>
                    <Card variant="outlined" sx={{ flex: 1, p: 1, display: 'flex', justifyContent: 'center' }}>
                        <Bar
                            data={{
                                labels: moyennes.map((m) => m.province),
                                datasets: [{
                                    label: `Prix moyen`,
                                    data: moyennes.map((m) => m.moyenne),
                                    backgroundColor: Colors.secondary,
                                    borderRadius: 4,
                                }],
                            }}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: { display: false },
                                    datalabels: {
                                        anchor: "end",
                                        align: "top",
                                        formatter: (v) => v.toFixed(0),
                                        font: { size: 10, weight: 'bold' }
                                    },
                                },
                                scales: {
                                    y: { display: false },
                                    x: { grid: { display: false }, ticks: { font: { size: 10 } } }
                                },
                            }}
                        />
                    </Card>
                </Grid>
{/* Graphique end  */}



               
            </Grid>
        </Stack>
    );
};

export default PrixMoyenProduitParprovince;